var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-tabs',{attrs:{"tabs":[
      {label:'Записи', name:'medRecords', perm:'medrecordsRecord', path:'/medRecord/record/'},
      {label:'Заявки в лабораторию', name:'labRequests', perm:'medrecordsLabrequest', path:'/medRecord/labRequest/'},
  ]},scopedSlots:_vm._u([{key:"default",fn:function({tabSelected}){return [(tabSelected==='medRecords' && _vm.mountedDelay)?_c('med-records'):_vm._e(),(tabSelected==='labRequests' && _vm.mountedDelay)?_c('lab-requests'):_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }